<template>
  <div class="MeskenDokum">
    <div class="KFatura lazer" style="height: 340px;">
      <div class="KFaturaIc">
        <div class="KHeader text-center">
          <LazerHeaderLogo></LazerHeaderLogo>
          <div class="clearfix"></div>
          <div class="KHeaderBilgi">
            <svg class="d-block mt-2" width="100%" height="20">
              <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="18"
                    font-weight="bold">ARIZA TESPİT BİLDİRİMİ
              </text>
            </svg>
            <div class="KHeaderTutar" style="padding: 10px">
              <svg class="d-block" width="100%" height="14">
                <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="12">
                  ÖLÇÜMLENDİRME İŞLEMLERİMİZE GÖRE
                </text>
              </svg>
              <svg class="d-block" width="100%" height="14">
                <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="12">
                  AŞAĞIDAKİ MESKENLERİN
                </text>
              </svg>
              <svg class="d-block" width="100%" height="14">
                <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="12">
                  SAYAÇLARINIDA HATALI VERİ AKIŞI
                </text>
              </svg>
              <svg class="d-block" width="100%" height="14">
                <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="12">
                  OLDUĞUNU ÖN GÖRMEKTEYİZ.
                </text>
              </svg>
              <svg class="d-block" width="100%" height="14">
                <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="12">
                  GEREKLİ KONTROLLERİ YAPARAK
                </text>
              </svg>
              <svg class="d-block" width="100%" height="14">
                <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="12">
                  OLASI SAYAÇ DEĞİŞİMİ DURUMUNDA
                </text>
              </svg>
              <svg class="d-block" width="100%" height="14">
                <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="12">
                  BİLGİ VERMENİZİ RİCA EDERİZ.
                </text>
              </svg>
              <br>
              <svg class="d-block" width="100%" height="16" v-if="f.Uyari" v-for="f in FaturaDokum">
                <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="16"
                      font-weight="bold">{{ f.kNo }} NOLU MESKEN
                </text>
              </svg>
            </div>

          </div>
        </div>
      </div>
      <div class="sayfasonu"></div>
    </div>
  </div>
</template>
<script>

import LazerHeaderLogo from "./LazerHeaderLogo";
export default {
  components:{LazerHeaderLogo},
  props: ['FaturaDokum', 'Fatura', 'AltToplam', 'Hesap_id']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Esayac/ArizaBildirimi.vue